import {
  Box,
  Button,
  Card,
  CardContent,
  CardHeader,
  Divider,
  Stack,
  styled,
  Typography,
} from "@mui/material";
import { common } from "@mui/material/colors";
import React from "react";
import { hColorful, hGrey, hPink, hSocialColor } from "../../theme";
import { setValueByBreakpoint } from "../../utils/helpers/setValueByBreakpoint.helpers";
import useBreakpoint from "../../utils/hooks/useBreakpoint";
import {
  ButtonInstagram,
  HomeContactUsStyle as classes,
} from "./HomeContactUs.style";

// images
import contactUsImage from "../../assets/images/home/5_Contact us/contact-us.png";
import facebookIcon from "../../assets/images/social/facebook-icon.png";
import instagramIcon from "../../assets/images/social/instagram-icon.png";
import lineIcon from "../../assets/images/social/line-icon.png";
import tiktokIcon from "../../assets/images/social/tiktok-icon.png";

const Item = styled(Box)(({ theme }) => ({
  ...theme.typography.body1,
  padding: theme.spacing(1),
  textAlign: "center",
  color: common.black,
}));

function Contact() {
  const bp = useBreakpoint();
  const items = [
    { label: "Phone", value: "092-455-2225" },
    { label: "E-mail", value: "marketing@hashu.co" },
    { label: "Business Hours", value: "24hr" },
  ];
  return (
    <Card sx={{ marginY: 10, boxShadow: "unset" }}>
      <CardContent>
        <Stack
          direction={bp === "xs" ? "column" : "row"}
          divider={
            <Divider
              orientation={bp === "xs" ? "horizontal" : "vertical"}
              flexItem
            />
          }
          justifyContent="space-around"
          spacing={5}
        >
          {items.map((item, idx) => {
            return (
              <Item key={idx}>
                <Typography
                  variant={setValueByBreakpoint(
                    bp,
                    "body1",
                    "body1",
                    "body1",
                    "h6"
                  )}
                  sx={{ color: hPink[300] }}
                >
                  {item.label}
                </Typography>
                <Typography
                  variant={setValueByBreakpoint(bp, "h6", "h6", "h6", "h5")}
                >
                  {item.value}
                </Typography>
              </Item>
            );
          })}
        </Stack>
      </CardContent>
    </Card>
  );
}

function TalkWithUs() {
  const bp = useBreakpoint();
  const talkWithUsItems = [
    {
      header: "Live Chat",
      buttons: [
        {
          id: "line",
          icon: lineIcon,
          label: "Hashu Line Official",
          color: `${hSocialColor["line"]}`,
          url: "https://lin.ee/dez0phm",
        },
        {
          id: "facebook",
          icon: facebookIcon,
          label: "facebook.com/HashU.co",
          color: `${hSocialColor["facebook"]}`,
          url: "https://www.facebook.com/HashU.co",
        },
      ],
    },
    {
      header: "Following us",
      buttons: [
        {
          id: "instagram",
          icon: instagramIcon,
          label: "instagram.com/HashU.co",
          color: undefined,
          url: "https://www.instagram.com/?hl=en",
        },
        {
          id: "tiktok",
          icon: tiktokIcon,
          label: "tiktok.com/@hashu.co",
          color: `${hSocialColor["tiktok"]}`,
          url: "https://www.tiktok.com/@hashu.co",
        },
      ],
    },
  ];
  return (
    <Card
      sx={{
        boxShadow: "unset",
        paddingTop: 7,
        paddingBottom: [7, 7, 28, 7, 7],
      }}
    >
      <CardHeader
        title={
          <Typography
            sx={{
              background: `linear-gradient(296.45deg, ${hColorful[100]}, ${hColorful[200]})`,
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: "transparent",
            }}
            textAlign="center"
            variant={setValueByBreakpoint(bp, "h6", "h5", "h5", "h4")}
            fontWeight="medium"
          >
            Talk with us
          </Typography>
        }
      />
      <CardContent sx={{ paddingTop: "unset" }}>
        <Box
          display="flex"
          flexDirection={bp === "xs" ? "column-reverse" : undefined}
          justifyContent="center"
          alignItems="center"
        >
          <Box
            width={["100%", "40%", "40%", "30%"]}
            display="flex"
            justifyContent="center"
          >
            <img
              src={`${contactUsImage}`}
              alt="faq"
              style={{
                width: setValueByBreakpoint(
                  bp,
                  "200px",
                  "200px",
                  "200px",
                  "240px"
                ),
                objectFit: "contain",
              }}
            />
          </Box>
          <Box width={["100%", "40%", "40%", "30%"]}>
            {talkWithUsItems.map((item, idx) => {
              return (
                <Box
                  key={idx}
                  sx={{
                    height: "150px",
                    display: "flex",
                    flexWrap: "wrap",
                    alignContent: "space-between",
                    justifyContent: "center",
                    paddingY: "20px",
                  }}
                >
                  <Typography
                    variant={setValueByBreakpoint(
                      bp,
                      "body2",
                      "h6",
                      "h6",
                      "h6"
                    )}
                    sx={{ color: hGrey[700] }}
                  >
                    {item.header}
                  </Typography>
                  {item.buttons.map((button, bIdx) => {
                    return button.id !== "instagram" ? (
                      <Button
                        key={"b" + bIdx}
                        fullWidth
                        variant="outlined"
                        sx={{ color: button.color }}
                        onClick={() => {
                          window.open(button.url);
                        }}
                      >
                        <img
                          src={`${button.icon}`}
                          alt={`icon${bIdx}`}
                          width="24px"
                        ></img>
                        <Typography
                          sx={{
                            paddingLeft: "10px",
                          }}
                        >
                          {button.label}
                        </Typography>
                      </Button>
                    ) : (
                      <ButtonInstagram
                        key={"b" + bIdx}
                        fullWidth
                        onClick={() => {
                          window.open(button.url);
                        }}
                      >
                        <img
                          src={`${button.icon}`}
                          alt={`button-ig${bIdx}`}
                          width="24px"
                        ></img>
                        <Typography
                          sx={{
                            paddingLeft: "10px",
                          }}
                        >
                          {button.label}
                        </Typography>
                      </ButtonInstagram>
                    );
                  })}
                </Box>
              );
            })}
          </Box>
        </Box>
      </CardContent>
    </Card>
  );
}

function ContactUs() {
  const bp = useBreakpoint();
  return (
    <Box sx={classes.contentMain}>
      <Box id="back-to-top-anchor" sx={classes.headerBackground}></Box>
      <Box width={["100%", "100%", "90%", "80%"]}>
        <Box pt={[15, 20, 20, 30]}>
          <Box textAlign="center">
            <Typography
              variant={setValueByBreakpoint(bp, "h4", "h3", "h3", "h2")}
            >
              Contact Us
            </Typography>
            <br />
            <Typography
              variant={setValueByBreakpoint(bp, "h6", "h5", "h5", "h4")}
              color={"text.secondary"}
            >
              Get in touch and let us know how we can help
            </Typography>
          </Box>
        </Box>
        <Box>
          <Contact />
          <TalkWithUs />
        </Box>
      </Box>
    </Box>
  );
}

export default ContactUs;
